"use strict";
function tripCostValidator(minimum, maximum) {
    return function (control) {
        var value = control.value;
        var numberValue = Number(value);
        if (Number.isNaN(numberValue)) {
            return { 'invalid': value };
        }
        else if (isSupplied(minimum) && numberValue < minimum) {
            return { 'min': numberValue };
        }
        else if (isSupplied(maximum) && numberValue > maximum) {
            return { 'max': numberValue };
        }
        return null;
    };
    function isSupplied(value) {
        return (value !== null && value !== undefined);
    }
}
exports.tripCostValidator = tripCostValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/trip-cost.validator.js